<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="新增抵押"
      width="800px"
      @close="closeDialog"
    >
      <el-form :model="val" ref="form" :rules="rules" label-width="150px">
        <el-form-item label="借贷币种：" prop="borrowCoinType">
          <el-select v-model="val.borrowCoinType">
            <el-option
              v-for="item in coinTypeList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="抵押币种：" prop="mortgageCoinType">
          <el-select v-model="val.mortgageCoinType">
            <el-option
              v-for="item in coinTypeList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="借贷比例：" prop="borrowingMortgageScale">
          <el-input-number
            v-model="val.borrowingMortgageScale"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="爆仓比例：" prop="burstScale">
          <el-input-number
            v-model="val.burstScale"
            :min="0"
            :step="0.1"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="警告比例：" prop="warnScale">
          <el-input-number
            v-model="val.warnScale"
            :min="0"
            :step="0.1"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="最小抵押数量：" prop="minMortgageAmount">
          <el-input-number v-model="val.minMortgageAmount"></el-input-number>
        </el-form-item>
        <el-form-item label="抵押精度：" prop="mortgagePrecision">
          <el-input-number v-model="val.mortgagePrecision"></el-input-number>
        </el-form-item>
        <el-form-item label="借币精度：" prop="borrowPrecision">
          <el-input-number v-model="val.borrowPrecision"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'cornucopiaCreate',
  data() {
    return {
      dialogVisible: false,
      val: {},
      rules: {
        borrowCoinType: {
          required: true,
          message: '请填写'
        },
        mortgageCoinType: {
          required: true,
          message: '请填写'
        },
        borrowingMortgageScale: {
          required: true,
          message: '请填写'
        },
        burstScale: {
          required: true,
          message: '请填写'
        },
        warnScale: {
          required: true,
          message: '请填写'
        },
        minMortgageAmount: {
          required: true,
          message: '请填写'
        },
        borrowPrecision: {
          required: true,
          message: '请填写'
        },
        mortgagePrecision: {
          required: true,
          message: '请填写'
        }
      }
    };
  },
  components: {},
  computed: {
    ...mapState('mortgage', ['coinTypeList'])
  },
  methods: {
    ...mapActions('mortgage', ['create']),
    closeDialog() {
      this.dialogVisible = false;
      this.detail = {};
      this.$refs['form'].resetFields();
    },
    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.doSave();
        }
      });
    },
    doSave() {
      this.create({ ...this.val }).then(() => {
        this.$message({
          message: '添加成功！',
          type: 'success'
        });
        this.dialogVisible = false;
        this.$emit('refresh');
      });
    }
  }
};
</script>

<style lang="less"></style>
